export default __webpack_public_path__ + "static/assets/2e0f5b9b7a06c2d50004bb89f4069e20.png";